export function formatPrice(value: number, currencyFormat: string): string {
  return currencyFormat.replace('{value}', value.toFixed(2));
}
